import React, { useState, useEffect } from 'react';
import { FormControlLabel, RadioGroup, Radio, Button } from "@material-ui/core";
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import baseUrl from '../../config/config';
import { makeStyles } from '@material-ui/styles';

export default function Issues(props){
    function StyledRadio(props) {
        const useStyles = makeStyles({
            root: {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            }
        })
        const classes = useStyles();
        return (
            <Radio
                className={classes.root}
                disableripple="true"
                color="default"
                checkedIcon={<CheckCircleIcon className="checkedIcon" />}
                icon={<RadioButtonUncheckedIcon />}
                {...props}
            />
        );
    }
    return(
        <div className="form-question">
            <div className="form-content" >
                <h4 className="form-content-heading m-0 mb-4">
                    Are you aware of any of the following?
                </h4>
                <ol style={{paddingInlineStart:"20px"}}>
                    <li>
                        <p>Room additions, structural modifications, or other alterations or repairs made without necessary permits</p>
                        <div className="py-1">
                            <RadioGroup
                                row 
                                name="alteration_1"
                                value={props.values.alteration_1}
                                onChange={props.handleChange}
                            >
                                <div>
                                    <FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
                                </div>
                                <div>
                                    <FormControlLabel value="no" control={<StyledRadio />} label="No" />
                                </div>
                            </RadioGroup>
                        </div>
                    </li>
                    <li>
                        <p>Room additions, structural modifications, or other alterations or repairs not in compliance with building codes</p>
                        <div className="py-1">
                            <RadioGroup
                                row 
                                name="alteration_2"
                                value={props.values.alteration_2}
                                onChange={props.handleChange}
                            >
                                <div>
                                    <FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
                                </div>
                                <div>
                                    <FormControlLabel value="no" control={<StyledRadio />} label="No" />
                                </div>
                            </RadioGroup>
                        </div>
                    </li>
                    <li>
                        <p>Any settling from any cause, or slippage, sliding, or other soil problems</p>
                        <div className="py-1">
                            <RadioGroup
                                row 
                                name="any_settling"
                                value={props.values.any_settling}
                                onChange={props.handleChange}
                            >
                                <div>
                                    <FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
                                </div>
                                <div>
                                    <FormControlLabel value="no" control={<StyledRadio />} label="No" />
                                </div>
                            </RadioGroup>
                        </div>
                    </li>
                    <li>
                        <p>Flooding, drainage or grading problems</p>
                        <div className="py-1">
                            <RadioGroup
                                row 
                                name="flooding"
                                value={props.values.flooding}
                                onChange={props.handleChange}
                            >
                                <div>
                                    <FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
                                </div>
                                <div>
                                    <FormControlLabel value="no" control={<StyledRadio />} label="No" />
                                </div>
                            </RadioGroup>
                        </div>
                    </li>
                    <li>
                        <p>Major damage to the property or any of the structures from fire, earthquake, floods, or landslides</p>
                        <div className="py-1">
                            <RadioGroup
                                row 
                                name="major_damage"
                                value={props.values.major_damage}
                                onChange={props.handleChange}
                            >
                                <div>
                                    <FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
                                </div>
                                <div>
                                    <FormControlLabel value="no" control={<StyledRadio />} label="No" />
                                </div>
                            </RadioGroup>
                        </div>
                    </li>
                </ol>
                {/* <ol>
                    {props.conditionList.map((condition,index)=>{
                        return(
                            <>
                            <li key={condition.property_condition_details_id}>{condition.property_condition_detail_name}</li>
                            <div className="py-2">
                                <RadioGroup
                                    row name="other_issues"
                                    // value={props.values.other_fees}
                                    // onClick={resetInputField}
                                    // onChange={props.handleChange} 
                                    >
                                    <div>
                                        <FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
                                    </div>
                                    <div>
                                        <FormControlLabel value="no" control={<StyledRadio />} label="No" />
                                    </div>
                                </RadioGroup>
                            </div>
                            </>
                        )
                        })}
                </ol> */}
            </div>
        </div>    
    )
}